<template>
  <register-container :step="step">
      <div class="card-body">
          <h1 class="head-title font-weight-bold text-center">Submit Compliance Application</h1>
          <p class="mb-5 text-center">Verify your Compliance documents with Strata Connex</p>
          <b-form
              @submit.prevent="formSubmitted"
              @keydown="form.onKeydown($event)"
          >
              <div class="submit-app-tab mb-5">
                  <div class="mb-4">
                      <div class="verified-acc pt-3 pl-3">
                          <svg width="75" height="83" viewBox="0 0 84 92" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 21C17 21 25.3333 16.8334 42 4.33337C58.6667 16.8334 67 21 79.5 21C79.5 79.3334 42 87.6667 42 87.6667C42 87.6667 4.5 79.3334 4.5 21Z" stroke="white" stroke-width="8.06452" stroke-linejoin="round"/>
                              <path d="M29.5 46L37.8333 54.3333L54.5 37.6666" stroke="white" stroke-width="8.06452" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>

                          <h3 class="pb-4 text-white">
                              <span>Get verified by</span><br>
                              <strong>Strata Connex</strong>
                          </h3>
                      </div>

                      <div class="verification-subtxt pt-3">
                          <ul
                              class="verify-app"
                              style="margin: 0;"
                          >
                              <li>Cheapest Verification</li>
                              <li>Hasslefree sharing</li>
                              <li>Easiest way to quote</li>
                          </ul>

                          <div class="rate">
                              <p>$10</p>
                              <p class="time-span">per year</p>
                          </div>
                      </div>

                  </div>

                  <div class="form-div">
                      <h4 style="font-size:18px; color:#4E4B66;" class="font-weight-bold">Payment Details</h4>
                      <b-form-group label="Name on card">
                          <b-form-input
                              type="text"
                              v-model="form.card_name"
                              v-bind:class="{
                                    'is-invalid': form.errors.has('card_name')
                                }"
                          ></b-form-input>
                          <has-error :form="form" field="card_name"></has-error>
                      </b-form-group>

                      <b-form-group label="Card number">
                          <b-form-input
                              type="text"
                              v-model="form.card_number"
                              v-bind:class="{
                                    'is-invalid': form.errors.has('card_number')
                                }"
                          ></b-form-input>
                          <has-error :form="form" field="card_number"></has-error>
                      </b-form-group>
                      <b-row>
                          <b-col cols="12">
                              <b-form-group label="Expiry">
                                  <date-picker
                                      valueType="format"
                                      :format="'YYYY-MM-DD'"
                                      type="date"
                                      :hide-header="true"
                                      v-model="form.expiry_date"
                                      v-bind:class="{
                                                    'is-invalid': form.errors.has('expiry_date')
                                                }"
                                  ></date-picker>
                                  <has-error :form="form" field="expiry_date"></has-error>
                              </b-form-group>
                          </b-col>

                          <b-col cols="12">
                              <b-form-group label="CVV">
                                  <b-form-input
                                      type="text"
                                      v-model="form.cvv"
                                      v-bind:class="{
                                                    'is-invalid': form.errors.has('cvv')
                                                }"
                                  ></b-form-input>
                                  <has-error :form="form" field="cvv"></has-error>
                              </b-form-group>
                          </b-col>
                      </b-row>
                  </div>
              </div>

              <div class="btns-action d-flex justify-content-between">
                  <div class="back-step">
                      <b-button
                          :disabled="form.busy"
                          class="back-btn"
                          type="button"
                          variant="outline-primary"
                          @click="$router.go(-1)"
                      >Back
                      </b-button>
                  </div>

                  <b-button
                      class="skipped-btn mr-3 ml-md-auto"
                      :disabled="form.busy"
                      type="button"
                      variant="warning"
                      @click="submitForReview"
                  >Skip - Continue without Verification
                  </b-button>

                  <b-button
                      :disabled="form.busy"
                      type="submit"
                      variant="primary"
                      class="btn-grad"
                  >Next
                  </b-button>
              </div>
          </b-form>

      </div>
  </register-container>
</template>

<script>
import {Form, HasError} from "vform";
import SideBar from "../includes/SideBar.vue";
import FooterComponent from "../../../../pages/includes/FooterComponent.vue";
import RegisterContainer from "./RegisterContainer.vue";
Vue.component(HasError.name, HasError);

export default {
    props: ["step", 'sidebarListLinks'],
    components: {
        RegisterContainer,
        FooterComponent,
        SideBar
    },
    data() {
        return {
            form: new Form({
                card_name: "",
                card_number: "",
                expiry_date: "",
                cvv: ""
            })
        };
    },
    mounted() {
        this.fetchPaymentDetails();
    },
    methods: {
        formSubmitted() {
            this.$root.$data.bsLoader = true;
            this.form.post("api/contractor/payment-details/updateOrCreate").then(() => {
                this.submitForReview();
                this.$root.$data.bsLoader = false;
            }).catch((err) => {
                this.$root.$data.bsLoader = false;
            });

        },
        submitForReview() {
            this.$router.push({
                name: "account-under-review"
            });
        },
        fetchPaymentDetails() {
            this.$root.$data.bsLoader = true;
            axios
            .post("api/contractor/payment-details/getDetails", {
            })
            .then(response => {
                this.form.fill(response.data.payment_details);
                this.$root.$data.bsLoader = false;
            }).catch((err) => {
                this.$root.$data.bsLoader = false;
            });
        }
    }
};
</script>


<style scoped>
    .submit-app-tab {
        display: grid;
        grid-template-columns: repeat(auto-fit,minmax(300px, 1fr));
        gap: 1rem;
    }

    @media screen and (min-width: 770px) {
        .submit-app-tab {
            gap: 4rem;
        }
    }

    .btns-action {
        flex-wrap: wrap;
        gap: 1rem;
    }
</style>
